export default __webpack_public_path__ + "static/media/BookedPatient.ff24cbbb.svg";